// extracted by css-extract-rspack-plugin
export default {"categoryItem":"V7gDG","settingsButton":"O_NVF","categoryRow":"RqypY","selected":"QFRXB","expanded":"bFuJ5","itemIcon":"IrSme","itemLabel":"owGK9"};